import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PublishIcon from 'material-ui/svg-icons/editor/publish';
import UndoIcon from 'material-ui/svg-icons/content/undo';
import { Dialog, RaisedButton, IconButton, MenuItem, TextField } from 'material-ui';
import EmojiPicker from './pickers/EmojiPicker';
import _ from 'lodash';
import { getEntities } from 'dash-front/selectors';
import { updatePostMessage, updatePost } from 'dash-front/campaign/actions/posts';
import { approveWithPagination } from 'dash-front/campaign/actions/withPagination';
import { responseStatusIsOk } from 'dash-front/helpers';
import Feature from 'dash-front/hoc/withFeature';
import { FactList } from 'dash-front/campaign/containers/Posts/PostFacts';

class PublishDialog extends React.PureComponent {
    componentWillReceiveProps(props) {
        if (this.props.post !== props.post) {
            const message = _.get(props.post, 'content.message', '');
            const generatedMessages = _.get(props.post, 'content.generatedMessages', []);

            const nextObject = {
                generatedMessages
            };
            this.setState(curState => {
                if (!curState.message) {
                    nextObject.message = message;
                }

                if (curState.initialMessage !== message) {
                    //initial message was changed (new post opened) -> reset
                    nextObject.initialMessage = message;
                    nextObject.message = message;
                }

                return nextObject;
            });
        }
    }
    state = {
        message: '',
        generatedMessages: [],
        initialMessage: ''
    };

    assignInputRef = el => {
        if (el) {
            if (el.input instanceof Node) {
                this.inputRef = el.input;
            } else {
                this.inputRef = el.input.refs.input;
            }
        }
    };

    onPublish = () => {
        const { postId } = this.props;
        if (this.state.message !== this.state.initialMessage) {
            this.props.updateMessage(postId, this.state.message).then(res => {
                if (responseStatusIsOk(res.status)) {
                    this.props.approvePost(postId).then(() => this.props.close());
                }
            });
        } else {
            this.props.approvePost(postId).then(() => this.props.close());
        }
    };

    onMessageChange = message => this.setState({ message });

    undo = () => this.onMessageChange(this.state.initialMessage);

    renderPost() {
        const { post } = this.props;
        const imagePath = _.get(post, 'content.picture');
        const videoSrc = _.get(post, ['content', 'video']);

        const messageChanged = this.state.message !== this.state.initialMessage;
        const onChange = (e, val) => this.onMessageChange(val);
        return (
            <div>
                <div style={{ textAlign: 'center' }}>
                    {!videoSrc && <img style={{ maxWidth: 600 }} src={imagePath} />}
                    {videoSrc && (
                        <video style={{ width: 600 }} loop autoPlay controls="controls">
                            <source src={videoSrc} />
                        </video>
                    )}
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <TextField
                        multiLine
                        floatingLabelText={'Message'}
                        name={'message'}
                        style={{ width: 600 }}
                        value={this.state.message}
                        onChange={onChange}
                        ref={this.assignInputRef}
                    />
                    <EmojiPicker inputRef={this.inputRef} value={this.state.message} onChange={onChange} />
                    {messageChanged ? (
                        <IconButton tooltip={'Undo'} onTouchTap={this.undo}>
                            <UndoIcon />
                        </IconButton>
                    ) : null}
                </div>
            </div>
        );
    }

    renderGeneratedMessages() {
        const generatedMessages = Array.isArray(this.state.generatedMessages) ? this.state.generatedMessages : [];
        const succeessfulMessages = generatedMessages.filter(message => message.succeed);
        if (!succeessfulMessages.length) {
            return null;
        }
        return (
            <div>
                <p>Automatically generated messages</p>
                {succeessfulMessages.map((el, index) => (
                    <MenuItem primaryText={el.result} key={index} onTouchTap={() => this.onMessageChange(el.result)} />
                ))}
            </div>
        );
    }

    renderFacts() {
        const { facts, hasResolvedFacts } = this.props.post;
        if (!hasResolvedFacts) {
            return null;
        }
        return (
            <div>
                <p>Facts</p>
                <FactList facts={facts} onClick={this.onMessageChange} />
            </div>
        );
    }

    renderContent() {
        const { post } = this.props;
        if (!post) {
            return null;
        }
        return (
            <div>
                {this.renderPost()}
                <Feature feature={'messageServices'}>{this.renderGeneratedMessages()}</Feature>
                <Feature feature={'messageServices'}>{this.renderFacts()}</Feature>
                <RaisedButton
                    primary
                    label={'Publish'}
                    style={{ marginTop: 12 }}
                    onTouchTap={this.onPublish}
                    icon={<PublishIcon />}
                />
            </div>
        );
    }

    render() {
        const { postId, close } = this.props;
        const open = Boolean(postId);
        return (
            <Dialog
                open={open}
                className={'no-padding-dialog'}
                dialogContentStyle={{
                    width: '90%',
                    maxWidth: 'none'
                }}
                autoScrollBodyContent
                repositionOnUpdate
                autoDetectWindowHeight
                modal={false}
                title={'Publish post'}
                onRequestClose={close}
            >
                {this.renderContent()}
            </Dialog>
        );
    }
}

PublishDialog.propTypes = {
    postId: PropTypes.string,
    post: PropTypes.object,
    close: PropTypes.func,
    updateMessage: PropTypes.func,
    updatePost: PropTypes.func,
    approvePost: PropTypes.func,
    publish: PropTypes.func
};

export default connect(
    (state, { postId }) => ({
        post: _.get(getEntities(state), ['posts', postId])
    }),
    (dispatch, { campaignId }) => ({
        updateMessage: (postId, message) => dispatch(updatePostMessage(postId)(message)),
        updatePost: (postId, updates) => dispatch(updatePost(postId)(updates)),
        approvePost: postId => dispatch(approveWithPagination(postId))
    })
)(PublishDialog);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/PublishDialog.js
 **/